module.exports = __webpack_public_path__ + "img/sprinkle-4.54d43d0b.webp";